/**
 * Formats a phone number as the user types.
 * Strips non-digits, caps at 10, and inserts formatting progressively:
 * 865 → 865  |  8655 → (865) 5  |  8655550100 → (865) 555-0100
 */
export function formatPhoneInput(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

/**
 * Formats a phone number string for display.
 * - 10 digits  → (XXX) XXX-XXXX
 * - 11 digits starting with 1 → +1 (XXX) XXX-XXXX
 * - Anything else → returned as-is (handles international, extensions, etc.)
 */
export function formatPhone(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits[0] === '1') {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return phone;
}
